import {useTranslation} from '@aboutyou/i18n';
import {COLORS, FONT_SIZES, FONT_WEIGHTS} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {FloatingBadgesCSS} from '../../Coupons/CouponBadges/CouponBadges';

interface HotDealBadgeProps {
  label?: string;
  'data-testid'?: string;

  isUrgencyCard?: boolean;
}

export const HotDealBadge: FC<HotDealBadgeProps> = ({
  label: defaultLabel,
  'data-testid': dataTestId,

  isUrgencyCard,
}) => {
  const {t} = useTranslation();

  if (!defaultLabel && !isUrgencyCard) {
    return null;
  }

  const label = isUrgencyCard ? `⏰ ${t("DON'T MISS OUT")}` : defaultLabel;

  return (
    <Badge
      data-testid={`${dataTestId}${
        isUrgencyCard ? 'urgencyBadge' : 'HotDealBadge'
      }`}
      $isUrgencyBadge={isUrgencyCard}
    >
      {label}
    </Badge>
  );
};

const Badge = styled.div<{$isUrgencyBadge?: boolean}>`
  ${FloatingBadgesCSS}
  color: ${COLORS.White};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 1.16;
  padding-inline: 0 12px;

  ${({$isUrgencyBadge}) =>
    $isUrgencyBadge &&
    css`
      padding: 4px 12px 4px 4px;
    `}
`;
